import {initialData} from '@src/store/merchant/misc'
import {MerchantState} from '@src/store/merchant/type'
import {storageFactory} from '@src/utility/storageFactory'
import create from 'zustand'
import {persist} from 'zustand/middleware'

export const useMerchantStore = create<MerchantState>()(
  persist(
    (set, get) => ({
      ...initialData,
      reset: () => set({...initialData}),
      setDeviceId: deviceId => set({deviceId}),
      setFingerprintError: fingerprintError => set({fingerprintError}),
      setLeadId: leadId => set({leadId}),
      setOrigin: origin => set({origin}),
      setOtp: otp => set({otp}),
      setReturnToPassword: returnToPassword => set({returnToPassword}),
      update: (input, leadId = get().leadId, origin = get().origin) => {
        const actual = get().input
        const accepted_terms = input.accepted_terms ?? actual.accepted_terms
        const address = input.address ?? actual.address
        const bank_data = input.bank_data ?? actual.bank_data
        const business_corporate_name = input.business_corporate_name ?? actual.business_corporate_name
        const business_name = input.business_name ?? actual.business_name
        const business_number = input.business_number ?? actual.business_number
        const phone_number = input.phone_number ?? actual.phone_number
        const plan = input.plan ?? actual.plan
        const gmv = input.gmv ?? actual.gmv
        const has_password = input.has_password ?? actual.has_password
        const provider = input.provider ?? actual.provider
        const sector = input.sector ?? actual.sector
        const segment = input.segment ?? actual.segment
        const status = input.status ?? actual.status
        const email = input.email ?? actual.email
        const redirect_url = input.redirect_url ?? actual.redirect_url
        const responsible = input.responsible ?? actual.responsible
        const url = input.url ?? actual.url
        set({
          input: {
            accepted_terms,
            address,
            bank_data,
            business_corporate_name,
            business_name,
            business_number,
            email,
            gmv,
            has_password,
            phone_number,
            plan,
            provider,
            redirect_url,
            responsible,
            sector,
            segment,
            status,
            url
          },
          leadId,
          origin
        })
      }
    }),
    {
      getStorage: () => storageFactory(() => localStorage),
      name: 'merchant-store',

      serialize: state => JSON.stringify(state),
      // eslint-disable-next-line sort-keys-fix/sort-keys-fix
      deserialize: str => (typeof str === 'string' ? JSON.parse(str) : null)
    }
  )
)
